import GeneralTable from "../Tabellen/GeneralTable";
import { aufgabenHeader, hiddenColumns } from "../Tabellen/ConstTabKopf/AufgabenHeader";
import { useEffect, useState } from "react";
import AufgabeButton from "./AufgabeButton";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";

export default function AufgabenLaden({hausaufgabenInstance}) {
    const [taskData, setTaskData] = useState([]);
    const [numberUndones, setNumberUndones] = useState(-1);
    const [numberTopics, setNumberTopics] = useState(-1);

    useEffect(() => {
        hausaufgabenInstance.getNumberOfUndoneTasks((error, data, response) => {
            if (error) {
                console.log(error);
                FehlerauswertungErrResp(error, response);
            } else {
                setNumberUndones(data);
            }
        });

        hausaufgabenInstance.getNumberOfUndoneTopics((error, data, response) => {
            if (error) {
                console.log(error);
                FehlerauswertungErrResp(error, response);
            } else {
                setNumberTopics(data);
            }
        });

        hausaufgabenInstance.getAllUndoneTasks((error, data, response) => {
            if (error) {
                console.log(error);
                FehlerauswertungErrResp(error, response);
            } else {
                setTaskData(data);
            }
        });
    }, [hausaufgabenInstance]);

    const reloadData = () => {
        hausaufgabenInstance.getNumberOfUndoneTasks((error, data, response) => {
            if (error) {
                console.log(error);
                FehlerauswertungErrResp(error, response);
            } else {
                setNumberUndones(data);
            }
        });

        hausaufgabenInstance.getNumberOfUndoneTopics((error, data, response) => {
            if (error) {
                console.log(error);
                FehlerauswertungErrResp(error, response);
            } else {
                setNumberTopics(data);
            }
        });

        hausaufgabenInstance.getAllUndoneTasks((error, data, response) => {
            if (error) {
                console.log(error);
                FehlerauswertungErrResp(error, response);
            } else {
                setTaskData(data);
            }
        });
    }
    const changeStateButton = {
        id: "toDid",
        Header: "",
        keyword: "toDid",
        Cell: ({row}) => <AufgabeButton rowEntry={row.original} instance={hausaufgabenInstance} reload={reloadData}/>
    }
    return (
        <div>
            {numberUndones>=0 && <div>
                    <h3>Offene Aufgaben:</h3>
                    <p>{numberUndones}</p>
                </div>}

                {numberTopics>=0 && <div>
                    <h3>Offene Themenbereiche:</h3>
                    <p>{numberTopics}</p>
                </div>}

        {taskData && <div>
            {/* <aside>{JSON.stringify(taskData)}</aside> */}
            <GeneralTable data={taskData} columns={aufgabenHeader} hiddenColumns={hiddenColumns} additionalColumns={[changeStateButton]}/>
        </div>}
        </div>
        
    )

    
}